<template>
  <div id="zwsq">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'zwsq'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/guide/zwsq/Zwsq.vue